/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_dynamodb_all_tables_region": "eu-west-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "Users-prod",
            "region": "eu-west-1"
        }
    ],
    "aws_user_files_s3_bucket": "cmakbucket134529-prod",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:d62f8e58-a844-4d00-93b2-f9296d542304",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_z93WT97LO",
    "aws_user_pools_web_client_id": "5cigerpe8hdfm7m0407894ed7b",
    "oauth": {
        "domain": "cmakauth-prod.auth.eu-west-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://registrace.americkykongres.cz/",
        "redirectSignOut": "https://registrace.americkykongres.cz/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME",
        "PICTURE"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "apicmakprofile",
            "endpoint": "https://5xhriebve6.execute-api.eu-west-1.amazonaws.com/prod",
            "region": "eu-west-1"
        }
    ]
};


export default awsmobile;
